module.exports = __webpack_public_path__ + "img/Vector.50d948a1.svg";